import styles from "./styles.module.scss";
import primaryComponents from "../../../primaryComponents";
import secondaryComponents from "../..";
import {
  BillBtnIcon,
  CloseIcon,
  PendBtnIcon,
} from "../../../../assets/svgIcons";
import { formatCurrency } from "../../../../helpers";
import { CheckoutGroup } from "../CheckoutGroup";
import { useSellModeCart } from "./useSellModeCart";
import Images from "../../../../assets/images";
import { CartPriceSummary } from "../CartPriceSummary";
import { useNavigate } from "react-router-dom";
import { pathConstants } from "../../../../routes/pathContants";
import { CartExtraButtonGroup } from "../CartExtraButtonGroup";

export const SellModeCart = ({ closeModal = () => {} }) => {
  const {
    isGeneratingBill,
    store_id,
    storeDetails,
    totalCalculatedPrice,
    cartItems,
    total_items,
    clearCartItem,
    isPendingCheckout,
    handleAddToCart,
    handleReduceCartItem,
    addCartItemToLocalStorage,
    handlePendCheckout,
    handleGenerateBill,
  } = useSellModeCart();
  const navigate = useNavigate();
  const totalItemAmount = cartItems?.reduce(
    (accumulator, item) =>
      Number(item?.quantity) * Number(item?.unit_price) + Number(accumulator),
    0,
  );

  return (
    <>
      <section className={styles.sellModeCart}>
        <div className={styles.sellModeCart__mobileTop}>
          <primaryComponents.Button
            classNames={"ml-auto btn btn--outline smallBtn mt-1 mr-1"}
            onClick={closeModal}
          >
            <CloseIcon
              className="mr-1 dark--text"
              style={{ fontSize: "20px" }}
            />
            Close
          </primaryComponents.Button>
        </div>

        <CheckoutGroup
          style={{ borderRadius: "4px", padding: "5px 12px" }}
          btnStyle={{
            height: "55px",
            background: "white",
            color: "#7647ee",
            borderColor: "#ddd",
          }}
          storeDetails={storeDetails}
        />

        {/* cart items section */}
        <secondaryComponents.LoaderHelper
          // isLoading={isFetchingCartItems}
          classNames="mt-3"
        >
          {/* cart body */}
          {cartItems?.length > 0 ? (
            <div className={styles.sellModeCart__middle}>
              <primaryComponents.Button
                classNames="ml-auto btn btn--outline-red smallBtn"
                onClick={clearCartItem}
                style={{
                  width: "fit-content",
                  minHeight: "35px",
                  fontSize: "14px",
                  padding: "0 20px",
                }}
              >
                Clear All
              </primaryComponents.Button>
              {cartItems?.map((item, index) => (
                <secondaryComponents.ProductCarting
                  key={item?.id + index}
                  cartDetails={item}
                  handleAddToCart={handleAddToCart}
                  handleReduceCartItem={handleReduceCartItem}
                  cartIndex={index}
                  addCartItemToLocalStorage={addCartItemToLocalStorage}
                />
              ))}
            </div>
          ) : (
            <div style={{ margin: "auto 0" }} className="text-center w-100">
              <img src={Images.productsEmptyState} alt="" width={"150px"} />
              <h5 className="mt-3 text-center">
                You have no products in your cart
              </h5>
              <p>When you select products, they would appear here.</p>
            </div>
          )}
        </secondaryComponents.LoaderHelper>

        <div className={styles.cartSummary}>
          <CartPriceSummary />
        </div>

        <div className={styles.sellModeCart__bottom}>
          <CartExtraButtonGroup
            storeDetails={storeDetails}
            totalCalculatedPrice={totalItemAmount}
            style={{ height: "55px" }}
          />

          {/* <div className={styles.sellModeCart__bottom__primary}> */}
          <primaryComponents.Button
            isDisabled={total_items === 0}
            classNames="btn btn--primary cover"
            onClick={() =>
              navigate(pathConstants.SELL_MODE_CHECKOUT({ store_id: store_id }))
            }
            style={{ height: "55px" }}
          >
            Checkout {total_items} {total_items > 1 ? "items " : "item "}(
            {formatCurrency({
              value: totalCalculatedPrice,
              currencyCode: storeDetails?.currency_code,
            })}
            )
          </primaryComponents.Button>
          <div className="d-flex" style={{ gap: "7px" }}>
            {storeDetails?.allow_generate_bill ? (
              <secondaryComponents.NavigateWithPermission
                permissionParentKey={"Inventory Management"}
                permissionChildKey="can_generate_bill"
              >
                <primaryComponents.Button
                  isLoading={isGeneratingBill}
                  isDisabled={total_items === 0 || isGeneratingBill}
                  loadingText="Generating bill..."
                  classNames="btn btn--outline cover"
                  onClick={() => handleGenerateBill()}
                  primarySpinner={false}
                >
                  <BillBtnIcon className="mr-1" />
                  Generate Bill
                </primaryComponents.Button>
              </secondaryComponents.NavigateWithPermission>
            ) : null}
            <primaryComponents.Button
              classNames="btn btn--outline-yellow cover"
              onClick={() => handlePendCheckout()}
              isDisabled={total_items === 0}
              isLoading={isPendingCheckout}
              loadingText="Pending..."
            >
              <PendBtnIcon className="mr-1" />
              Pend Order
            </primaryComponents.Button>
          </div>
          {/* </div> */}
        </div>
      </section>
    </>
  );
};
